import { createNativeInstance } from '@transifex/native';

import { getTransifexToken } from '../config/runtimeConfig';

/**
 * Transifex Native instance bound to login's own Transifex project —
 * distinct from a host app's default `tx` instance so their translation
 * caches don't collide. LoginRoot scopes `useT()` calls to this instance
 * via TXProvider.
 *
 * Created with an empty token at module load; `configureLoginTxToken()`
 * runs at LoginRoot mount (or in LoginStrings, with a host's token) and
 * re-inits with the resolved token. Missing token doesn't throw — screens
 * fall back to source (English) strings.
 */
export const loginTx = createNativeInstance({ token: '' });

export const configureLoginTxToken = (token: string = getTransifexToken()): void => {
  if (loginTx.token === token) return;
  loginTx.init({ token });
};
